import moment from 'moment'

export const recall = {
    id: '',
    module: '',
    customerComplaintId: '',
    complaintNo: '',
    ncrId: '',
    ncrNo: '',
    recallNo: '',
    complaintCategoryId: '',
    complaintCategoryName: '',
    analysis: '',
    recallProcessStep: '',
    nonConformanceProcessStep: '',
    claimCost: '',
    handlingRecallCost: '',
    nonConformanceHandlingCost: '',
    dischargePortId: '',
    dischargePortName: '',
    countryId: '',
    countryName: '',
    productId: '',
    productName: '',
    otherCost: '',
    totalCost: 0,
    recallStartDate: moment().format('YYYY-MM-DD'),
    recallEndDate: moment().format('YYYY-MM-DD'),
    createdBy: '',
    updatedBy: '',
    status: '',
    createdAt: moment().format('YYYY-MM-DD'),
    updatedAt: moment().format('YYYY-MM-DD'),
}

export const recallApproval = {
    id: '',
    customerComplaintId: '',
    complaintNo: '',
    ncrId: '',
    recallNo: '',
    complaintCategoryId: '',
    complaintCategoryName: '',
    analysis: '',
    recallProcessStep: '',
    nonConformanceProcessStep: '',
    claimCost: '',
    handlingRecallCost: '',
    nonConformanceHandlingCost: '',
    otherCost: '',
    recallStartDate: moment().format('YYYY-MM-DD'),
    recallEndDate: moment().format('YYYY-MM-DD'),
    comment: '',
    createdBy: '',
    updatedBy: '',
    status: '',
    createdAt: moment().format('YYYY-MM-DD'),
    updatedAt: moment().format('YYYY-MM-DD'),
}

export const customerComplaint = {
    complaintNo: '',
    customerName: '',
    productName: '',
}

export const ncr = {
    ncrNo: '',
    productName: '',
}


export const customerComplaintCorrectiveInternal = {
    id: '',
    correctiveActionNumber: '',
    customerComplaintId: '',
    rootCause: '',
    corrective: '',
    correctivePicId: '',
    correctiveTargetDate: moment().format('YYYY-MM-DD'),
    preventive: '',
    preventivePicId: '',
    preventiveTargetDate: moment().format('YYYY-MM-DD'),
}